export default {
  common: {
    error: "Något gick fel",
    reload: "Ladda om",
    errorNotification: "Vi har blivit meddelade och kommer att åtgärda det så snart som möjligt. Om problemet kvarstår, vänligen",
    contactUs: "kontakta oss.",
    language: "Språk",
    loading: "Laddar...",
    loadingText: "Laddar",
    save: "Spara",
    savedSuccessfully: "Sparat framgångsrikt",
    saving: "Sparar...",
    cancel: "Avbryt",
    edit: "Redigera",
    delete: "Radera",
    add: "Lägg till",
    search: "Sök",
    filter: "Filter",
    clear: "Rensa",
    preview: "Förhandsvisning",
    default: "Standard: {{value}}",
    optional: "Valfritt",
    required: "Obligatoriskt",
    noData: "Inga data",
  },
  // Places navigation
  places: {
    navigation: {
      locations: "Platser",
      cities: "Städer", 
      regions: "Regioner",
      countries: "Länder",
      showOnMap: "Visa på karta",
      addLocation: "Lägg till plats"
    },
    welcome: {
      title: "Välkommen till Locations So Super.",
      subtitle: "Välj en sektion från navigeringen för att komma igång."
    }
  },

  // Cities section
  cities: {
    title: "Städer",
    resourceSingular: "stad",
    resourcePlural: "städer",
    headings: {
      name: "Namn",
      status: "Status",
      locations: "Platser", 
      region: "Region",
      country: "Land"
    },
    breadcrumbs: {
      cities: "Städer"
    }
  },

  // Countries section  
  countries: {
    title: "Länder",
    resourceSingular: "land", 
    resourcePlural: "länder",
    headings: {
      name: "Namn",
      status: "Status",
      locations: "Platser",
      cities: "Städer",
      regions: "Regioner"
    },
    breadcrumbs: {
      countries: "Länder"
    }
  },

  // Regions section
  regions: {
    title: "Regioner",
    resourceSingular: "region",
    resourcePlural: "regioner", 
    headings: {
      name: "Namn",
      status: "Status",
      locations: "Platser",
      cities: "Städer",
      country: "Land"
    },
    breadcrumbs: {
      regions: "Regioner"
    }
  },

  // Map section
  map: {
    title: "Karta",
    breadcrumbs: {
      locations: "Platser"
    }
  },

  // Import section
  import: {
    title: "CSV-import",
    breadcrumbs: {
      locations: "Platser"
    },
    new: {
      title: "Importera platser via CSV",
      description: "Ladda ner en exempel CSV-mall för att se ett exempel på det format som krävs",
      sampleTemplate: "exempel CSV-mall",
      uploadAndContinue: "Ladda upp och fortsätt",
      abortOnError: "Avbryt vid fel",
      abortOnErrorHelp: "Om det finns ett fel kommer importen att avbrytas, visa felet och inga platser kommer att importeras.",
      needHelp: "Behöver du hjälp med att importera platser?"
    },
    show: {
      title: "CSV-import",
      youCanLeavePage: "Du kan lämna denna sida",
      backgroundMessage: "Din import kommer fortfarande att köras i bakgrunden",
      importProgress: "Importförlopp",
      imported: "Importerat",
      suffix: "platser",
      importLog: "Importlogg",
      cancelImport: "Avbryt import",
      cancelConfirmation: {
        title: "Avbryt import",
        message: "Är du säker på att du vill avbryta detta importjobb? Denna åtgärd kan inte ångras.",
        note: "Obs: För pågående jobb måste jobbet slutföras och det kommer att raderas direkt efteråt.",
        yesCancel: "Ja, avbryt import",
        noContinue: "Nej, fortsätt import"
      },
      report: "Rapport",
      failedLocations: "Misslyckade platser",
      uploadAnother: "Ladda upp en annan CSV",
      backToLocations: "Tillbaka till platser",
      importSucceeded: "Import lyckades",
      importFailed: "Import misslyckades"
    },
    messages: {
      uploadSuccess: "CSV har laddats upp framgångsrikt",
      uploadError: "Kunde inte ladda upp CSV",
      pending: "Import har inte startat ännu",
      inProgress: "Import pågår",
      completed: "Import slutförd",
      invalidHeader: "Följande kolumner krävs",
      invalidCsvFile: "Ogiltig CSV-fil",
      aborted: "Import avbruten",
      failed: "Import misslyckades",
      cancelled: "Import avbruten"
    },
    errors: {
      csvTooLarge: "CSV är för stor",
      languageNotEnabled: "Språket '{{language}}' är inte aktiverat för denna butik. Aktivera det först i Inställningar > Språk.",
      fieldNotTranslatable: "Fältet '{{field}}' är inte översättbart. Översättbara fält är: {{fields}}",
      locationError: "Plats med slug: {{slug}} - {{error}}",
      planLimit: "Du har nått din planbegränsning för platser"
    }
  },

  // Location form
  location: {
    index: {
      title: "Platser",
      addLocation: "Lägg till plats",
      import: "Importera",
      noPrioritySet: "Ingen prioritet inställd",
      published: "Publicerad",
      draft: "Utkast",
      resourceSingular: "plats",
      resourcePlural: "platser",
      headings: {
        name: "Namn",
        status: "Status", 
        city: "Stad",
        region: "Region",
        country: "Land",
        priority: "Prioritet"
      }
    },
    form: {
      title: "Lägg till plats",
      editTitle: "Redigera plats",
      basicInformation: "Grundinformation",
      name: "Namn",
      namePlaceholder: "t.ex. Brians Bricks",
      nameHelpDefault: "Standard: {{defaultName}}",
      details: "Detaljer",
      description: "Beskrivning",
      descriptionPlaceholder: "Berätta för kunderna vad som gör denna plats speciell",
      address: "Adress",
      addressPlaceholder: "123 Huvudgatan, Stad, Land",
      addressLine1: "Adressrad 1",
      addressLine2: "Adressrad 2",
      postalZipCode: "Postnummer",
      city: "Stad",
      stateProvinceRegion: "Stat / Provins / Region",
      country: "Land",
      phone: "Telefon",
      phonePlaceholder: "+46 8 123 45 67",
      email: "E-post", 
      emailPlaceholder: "butik@exempel.se",
      website: "Webbplats",
      websitePlaceholder: "https://www.exempel.se",
      image: "Bild",
      imagePlaceholder: "Ange bild-URL",
      status: "Status",
      statusActive: "Aktiv",
      statusInactive: "Inaktiv",
      statusDraft: "Utkast",
      priority: "Prioritet",
      priorityHelpText: "Platser med högre prioritet visas först i sökresultat",
      findOnMapButton: "Hitta på karta"
    },
    validation: {
      addressNotFound: "Kunde inte hitta adress",
      createSuccess: "Plats skapad framgångsrikt", 
      updateSuccess: "Plats uppdaterad framgångsrikt",
      checkFields: "Vänligen kontrollera dina fält",
      findOnMap: "Vänligen hitta din plats på kartan innan du sparar"
    },
    errors: {
      loading: "Fel vid laddning av plats"
    },
    actions: {
      save: "Spara plats",
      delete: "Radera plats",
      preview: "Förhandsvisning"
    },
    customFields: {
      title: "Anpassade fält",
      noCustomFields: "Inga anpassade fält konfigurerade",
      configureFields: "Konfigurera fält",
      emptyState: "Du har inte konfigurerat några anpassade fält ännu. Anpassade fält låter dig lägga till ytterligare information specifik för dina affärsbehov."
    },
    openingHours: {
      title: "Öppettider",
      checkboxLabel: "Denna plats har öppettider",
      statusOpen: "Öppen",
      statusOpen24h: "Öppen 24 timmar",
      statusClosed: "Stängd",
      openingTimeLabel: "Öppningstid",
      closingTimeLabel: "Stängningstid",
      days: {
        monday: "Måndag",
        tuesday: "Tisdag", 
        wednesday: "Onsdag",
        thursday: "Torsdag",
        friday: "Fredag",
        saturday: "Lördag",
        sunday: "Söndag"
      }
    },
    table: {
      sortOptions: {
        recentlyAdded: "Nyligen tillagd",
        recentlyModified: "Nyligen ändrad"
      },
      filters: {
        status: "Status",
        taggedWith: "Tagged med",
        locationStatus: "Platsstatus",
        noTagsToShow: "Inga taggar att visa",
        searchPlaceholder: "Sök"
      },
      bulkActions: {
        setPublished: "Sätt som publicerad",
        setUnpublished: "Sätt som opublicerad", 
        setPriority: "Sätt prioritet",
        deleteLocations: "Radera platser",
        exportCSV: "Exportera som CSV"
      },
      appliedFilters: {
        statusIs: "Status är {{status}}",
        taggedWith: "Tagged med {{tag}}",
        nameIncludes: "Namn innehåller {{search}}"
      },
      modals: {
        deleteTitle: "Radera platser",
        deleteMessage: "Är du säker på att du vill radera {{count}}?",
        deleteMessageAll: "Är du säker på att du vill radera alla platser?",
        prioritiseTitle: "Prioritera {{count}} platser",
        prioritiseTitleAll: "Prioritera alla platser",
        delete: "Radera",
        cancel: "Avbryt"
      },
      emptyState: {
        noResultsHeading: "Kunde inte hitta några {{resourcePlural}}",
        noResultsText: "Försök ändra filtren eller söktermen",
        noDataHeading: "Lägg till en plats för att fylla {{resourcePlural}}",
        addLocation: "Lägg till plats",
        importFromCSV: "Importera från CSV"
      },
      pagination: {
        label: "Sida {{page}} av {{pages}}"
      },
      messages: {
        updatedSuccessfully: "Uppdaterad framgångsrikt",
        deletedSuccessfully: "Raderad framgångsrikt", 
        exportedSuccessfully: "Exporterad framgångsrikt",
        error: "Något gick fel"
      }
    }
  },

  // SEO Editor
  seo: {
    title: "Sidinnehåll",
    editTemplate: "Redigera SEO-mall", 
    pageTitle: "Titel",
    pageDescription: "Beskrivning",
    metaTitle: "Titel",
    metaDescription: "Beskrivning",
    urlHandle: "URL-handtag",
    searchEnginePreview: "Förhandsvisning av sökmotorlistning",
    editMeta: "Redigera Meta",
    previewMeta: "Förhandsvisa Meta",
    loading: "Laddar...",
    editingLocaleHelp: "Redigerar {{locale}} innehåll."
  },

  // SEO Templates section
  seoTemplates: {
    title: "SEO-mallar",
    breadcrumbs: {
      seoTemplates: "SEO-mallar"
    },
    template: {
      title: "{{templateName}} mall - {{locale}}",
      discardChanges: "Ignorera ändringar"
    },
    form: {
      pageContent: "Sidinnehåll",
      searchEnginePreview: "Förhandsvisning av sökmotorlistning",
      title: "Titel",
      description: "Beskrivning",
      pageTitle: "Sidtitel",
      metaDescription: "Meta-beskrivning",
      editingLocaleHelp: "Redigerar {{locale}} översättningar. Tomma fält visar innehåll från {{defaultLocale}}.",
      defaultValue: "Standard: {{value}}"
    },
    language: {
      label: "Språk",
      defaultHelp: "Detta är ditt standardspråk",
      editingHelp: "Redigerar {{locale}} översättningar. Tomma fält visar {{defaultLocale}} innehåll."
    },
    banner: {
      multipleLanguagesDisabled: "Flera språk är inte aktiverade",
      enableInSettings: "Aktivera i Inställningar",
      multipleLanguagesInfo: "För att hantera SEO-mallar för flera språk, aktivera internationalisering i dina språkinställningar. Visar för närvarande endast {{locale}} mallar."
    },
    badges: {
      errors: "Fel!",
      unsaved: "Ej sparad"
    },
    messages: {
      saveSuccess: "SEO-mallar sparade framgångsrikt",
      saveError: "Kunde inte spara mallar",
      error: "Fel..."
    }
  },

  // Area form
  area: {
    form: {
      basicInformation: "Grundinformation",
      name: "Namn",
      save: "Spara",
      saving: "Sparar...",
      cancel: "Avbryt",
      yourLocationsIn: "Dina platser i {{name}}",
      tableHeadings: {
        name: "Namn",
        status: "Status",
        city: "Stad",
        region: "Region",
        country: "Land"
      },
      resourceName: {
        singular: "{{name}} plats",
        plural: "platser i {{name}}"
      }
    }
  },

  // Settings section
  settings: {
    navigation: {
      map: "Karta",
      tags: "Taggar",
      customFields: "Anpassade fält",
      languages: "Språk",
      plan: "Plan",
      addTag: "Lägg till tagg",
      addField: "Lägg till fält"
    },
    planBadges: {
      trial: "!",
      endsSoon: "Slutar snart"
    },
    common: {
      loading: "Laddar...",
      error: "Fel...",
      breadcrumbs: {
        settings: "Inställningar"
      },
      skeleton: {
        customFields: "Anpassade fält",
        addField: "Lägg till fält",
        name: "Namn",
        contentType: "Innehållstyp",
        usedIn: "Används i",
        field: "Fält",
        fields: "Fält"
      },
      messages: {
        savedSuccessfully: "{{setting}} inställningar sparade framgångsrikt",
        couldntSave: "Kunde inte spara {{setting}} inställningar"
      }
    },
    map: {
      title: "Karta",
      messages: {
        savedSuccessfully: "Kartinställningar sparade framgångsrikt",
        couldntSave: "Kunde inte spara inställningar"
      },
      mapboxToken: {
        title: "Mapbox-token",
        description: "Ange din Mapbox-token för att driva din butikssökare",
        label: "Mapbox-token",
        placeholder: "Ange token här för att fortsätta använda din karta.",
        placeholderManaged: "Ange token här för att fortsätta använda din karta när du har slut på gratis kartladdningar.",
        helpText: "Följ våra instruktioner för att skapa en Mapbox-nyckel, klistra sedan in din nyckel ovan. Om du stöter på problem, vänligen kontakta oss för hjälp.",
        linkInstructions: "instruktioner för att skapa en Mapbox-nyckel",
        linkSupport: "kontakta oss för hjälp"
      },
      managedToken: {
        title: "Kartladdningar",
        description: "Du har upp till {{max}} gratis kartladdningar med en hanterad token, efter det måste du skapa din egen token."
      },
      appearance: {
        title: "Utseende",
        description: "Ändra utseendet på din karta"
      },
      mapStyle: {
        title: "Kartstil",
        options: {
          streets: "Gator",
          outdoors: "Utomhus", 
          light: "Ljus",
          dark: "Mörk",
          satellite: "Satellit",
          satelliteStreets: "Satellitgator",
          navigationDay: "Navigation Dag",
          navigationNight: "Navigation Natt"
        }
      },
      searchBehaviour: {
        title: "Sökbeteende",
        description: "Styr hur besökare hittar platser på din karta.",
        geolocateLabel: "Uppskatta automatiskt besökarens plats och visa närliggande butiker",
        geolocateHelp: "Om geolokalisering lyckas kommer kartan att flytta sig för att fokusera nära besökaren. Om en uppskattad plats inte kan hittas kommer kartan att förbli på startpositionen.",
        filterBehaviour: {
          title: "Filterbeteende",
          all: {
            label: "Alla taggar",
            help: "För att en plats ska visas i filter måste den ha alla valda taggar"
          },
          any: {
            label: "Vilka taggar som helst", 
            help: "För att en plats ska visas i filter kan den ha någon av de valda taggarna"
          }
        },
        keepSearchInView: {
          label: "Håll sökmarkören i vyn",
          help: "När sökresultat visas kommer kartan att zooma ut för att visa alla matchande platser"
        },
        distanceUnits: {
          title: "Avståndsenheter",
          km: "Kilometer",
          miles: "Miles"
        },
        maxResults: {
          label: "Max resultat",
          help: "Begränsa antalet platser som visas i sökresultat",
          options: {
            results30: "30 resultat"
          }
        },
        maxDistance: {
          label: "Max avstånd", 
          help: "Visa endast platser inom detta avstånd från sökpunkten",
          options: {
            unlimited: "Obegränsat"
          }
        },
        showLocationNames: {
          label: "Visa platsnamn i förslag",
          help: "Visa platsnamn i sökförslag"
        },
        sortByPriority: {
          label: "Sortera efter prioritet istället för avstånd",
          help: "Det rekommenderas starkt att sätta ett maximalt avstånd (som inte är Obegränsat) om denna ruta är ikryssad. Annars kommer dina kunder att se avlägsna platser som har hög prioritet listade ovanför de som är inom ett rimligt avstånd från dem (eller deras sökfråga, mer specifikt)."
        }
      },
      searchResults: {
        title: "Sökresultat",
        description: "Styr hur platser returneras på din karta.",
        locationsLabel: "Sökresultattext",
        locationsHelp: "Text som visas ovanför sökresultat (t.ex. 'Visar 5 platser')",
        prefixLabel: "Sökresultatprefix", 
        prefixHelp: "Text som visas före antalet resultat"
      },
      popups: {
        title: "Popup-fönster",
        showPopups: {
          label: "Visa popup-fönster",
          help: "Visa platsdetaljer när besökare klickar på kartmarkörer"
        }
             },
       whitelabel: {
         title: "Whitelabel",
         hideLabel: "Dölj 'powered by' text",
         hideHelp: "Ta bort vår varumärkesprofilering från din butikssökare"
       }
    },
    languages: {
      title: "Språk",
      error: "Fel...",
      messages: {
        savedSuccessfully: "Språkinställningar sparade framgångsrikt",
        couldntSave: "Kunde inte spara språkinställningar"
      },
      banner: {
        upgradeTitle: "Flera språk kräver planuppgradering",
        upgradeAction: "Uppgradera till Superest",
        upgradeMessage: "Du kan fortfarande ändra ditt standardspråk, men att aktivera flera språk kräver en uppgradering.",
        disabledMessage: "Inställningar för flera språk är inaktiverade på din nuvarande plan"
      },
      defaultLanguage: {
        title: "Standardspråk", 
        description: "Välj ditt primära språk som ditt innehåll kommer att visas på.",
        label: "Standardspråk",
        help: "Detta språk kommer att användas när inget specifikt språk begärs"
      },
      internationalization: {
        title: "Internationalisering",
        description: "Aktivera flera språk. Nå fler kunder och öka din SEO.",
        enableLabel: "Aktivera flera språk",
        enableHelp: "Tillåt kunder att visa din butikssökare på olika språk"
      },
      supportedLanguages: {
        title: "Ytterligare stödda språk",
        description: "Välj ytterligare språk som du vill stödja. När du har aktiverat ett språk kommer du att se alternativet att tillhandahålla översättningar i hela appen. För stödda språk kommer standard SEO-mallarna, samt de vanliga variabla temana att genereras automatiskt.",
        defaultLocaleNote: "Detta är ditt standardspråk och kan inte inaktiveras",
        shopifyEnabled: {
          label: "Detta språk är aktiverat i min Shopify-butik",
          importantNote: "Viktigt:",
          description: "Avmarkera rutan ovan om detta språk inte är aktiverat och publicerat för din Shopify-butik. Det rekommenderas att aktivera språket för din Shopify-butik först genom att gå till Inställningar > Språk i din Shopify-administration om du inte redan har gjort det för en smidigare kundupplevelse."
        },
        urlFormats: {
          cleanUrls: "Rena URL:er:",
          betterSeo: "Bättre SEO och användarupplevelse",
          queryUrls: "Query-parameter URL:er:",
          considerEnabling: "Överväg att aktivera i Shopify för bättre URL:er"
        },
        preview: {
          button: "Förhandsvisning",
          tooltip: "Förhandsvisa {{language}} butikssökare"
        },
        tooltips: {
          noTemplates: "Inga standard SEO-mallar tillgängliga för detta språk. Du kan enkelt skapa anpassade översättningar."
        }
      }
    },
    tags: {
      title: "Taggar",
      addTag: "Lägg till tagg",
      error: "Fel",
      messages: {
        deletedSuccessfully: "Taggar raderade framgångsrikt",
        couldntDelete: "Taggar kunde inte raderas",
        savedSuccessfully: "Tagg sparad framgångsrikt",
        couldntSave: "Vänligen kontrollera dina fält",
        tagDeleted: "Tagg raderad framgångsrikt"
      },
      resourceName: {
        singular: "tagg",
        plural: "taggar"
      },
      filters: {
        anyGroup: "Vilken grupp som helst",
        inGroup: "I grupp",
        tagGroup: "Tagg grupp"
      },
      appliedFilters: {
        inGroup: "I {{group}} grupp",
        nameContains: "Tagg namn innehåller {{query}}"
      },
      bulkActions: {
        deleteTag: "Radera tagg",
        deleteTags: "Radera taggar"
      },
      form: {
        language: "Språk",
        title: "Titel",
        description: "Beskrivning",
        group: "Grupp",
        groupPlaceholder: "Välj grupp",
        addGroup: "Lägg till",
        editingTranslations: "Redigerar {{language}} översättningar. Tomma fält visar innehåll från {{defaultLanguage}}.",
        defaultValue: "Standard: {{value}}",
        image: "Bild",
        imageUrl: "Bild-URL"
      },
      actions: {
        save: "Spara",
        deleteTag: "Radera tagg"
      },
      new: {
        title: "Lägg till tagg",
        messages: {
          createSuccess: "Tagg skapad framgångsrikt",
          checkFields: "Vänligen kontrollera dina fält"
        },
        actions: {
          createTag: "Skapa tagg"
        }
      }
    },
    customFields: {
      title: "Anpassade fält",
      addField: "Lägg till fält",
      error: "Fel",
      resourceName: {
        singular: "Fält",
        plural: "Fält"
      },
      headings: {
        name: "Namn",
        contentType: "Innehållstyp",
        usedIn: "Används i"
      },
      emptyState: {
        heading: "Skapa och hantera dina anpassade fält",
        createAction: "Skapa fält",
        description: "Använd anpassade fält för unika attribut om dina platser. Dessa fält kan vara allt från sociala profiler till butikschefens namn och e-post"
      },
      pluralization: {
        location: "plats",
        locations: "platser"
      },
      form: {
        name: "Namn",
        contentType: "Innehållstyp",
        key: "Nyckel",
        keyPrefix: "location.fields.",
        keyHelp: "Använd denna nyckel för att komma åt en plats {{name}} innehåll i dina liquid-mallar.",
        translations: {
          title: "Översättningar",
          showTranslations: "Visa översättningar",
          hideTranslations: "Dölj översättningar",
          description: "Översättningar är valfria. Tomma fält visar {{language}} fältnamnet.",
          nameTranslation: "Namn ({{language}})",
          defaultValue: "Standard: {{value}}"
        }
      },
      messages: {
        savedSuccessfully: "Fält sparad framgångsrikt",
        couldntSave: "Fält kunde inte sparas",
        deletedSuccessfully: "Fält raderad framgångsrikt",
        couldntDelete: "Fält kunde inte raderas"
      },
      actions: {
        delete: "Radera"
      },
      new: {
        title: "Lägg till fält",
        messages: {
          savedSuccessfully: "Fält sparad framgångsrikt",
          couldntSave: "Fält kunde inte sparas"
        }
      },
      contentTypes: {
        text: "Text",
        textArea: "Textområde", 
        email: "E-post",
        number: "Nummer",
        phoneNumber: "Telefonnummer",
        time: "Tid",
        url: "URL"
      }
    },
    plan: {
      title: "Plan",
      error: "Fel",
      changePlan: "Ändra plan",
      usdPerMonth: "USD / månad",
      sections: {
        yourPlanIncludes: "Din plan inkluderar",
        nextBillingDate: "Nästa faktureringsdatum",
        trial: "Provperiod"
      },
      banners: {
        planUpdated: "Din plan har uppdaterats",
        thankYouUpgrading: "Tack för att du uppgraderade!",
        letUsKnow: "Låt oss veta",
        improvementText: "om det finns något vi kan göra bättre.",
        trialCancellation: {
          title: "Meddelande om provperiodens avbokning",
          message: "Din 14-dagars gratis provperiod kommer att avbokas när du uppgraderar till en betald plan."
        }
      },
      locations: {
        upTo: "Upp till",
        locations: "platser",
        unlimited: "Obegränsat antal platser",
        used: "används",
        ofUsed: "{{used}} av {{max}} används"
      },
      trial: {
        daysLeft: "{{days}} dagar kvar",
        daysUsed: "{{used}} av {{total}} dagar används",
        selectPlan: "Välj en plan",
        currentPlan: "Nuvarande plan",
        trialBadge: "Provperiod",
        currentBadge: "Nuvarande",
        yourTrialJustStarted: "Din provperiod började precis",
        trialEndsAfterToday: "Din provperiod slutar efter idag",
        trialEndsTomorrow: "Din provperiod slutar imorgon",
        daysLeftInTrial: "{{days}} dagar kvar i din provperiod",
        continueAddingLocations: "Fortsätt lägga till platser efter {{date}} genom att välja en plan",
        selectPlanToday: "Vänligen välj en plan idag för att fortsätta lägga till platser"
      },
      footer: {
        description: "Hantera eller ändra din Locations So Super plan. Se vår",
        termsOfService: "användarvillkor",
        and: "och",
        privacyPolicy: "integritetspolicy"
      },
      features: {
        analytics: {
          title: "Analys",
          description: "Ta reda på hur människor använder dina platser och var de söker efter"
        },
        internationalization: {
          title: "Stöd för flera språk",
          description: "Öka SEO och nå fler kunder i målgrupper genom att aktivera flera språk"
        },
        customThemes: {
          editLiquid: {
            title: "Redigera temats liquid-mallar",
            description: "Visa platsdata på vilket sätt du vill med tillgång till temats liquid"
          },
          editStructuredData: {
            title: "Redigera företagsstrukturerade data",
            description: "Redigera hur Google förstår sidor genom att redigera dina strukturerade data"
          }
        }
      },
      edit: {
        title: "Ändra plan",
        allPlansInclude: "Alla planer ovan inkluderar",
        needingMoreLocations: "Behöver fler platser?",
        footerQuestion: "Har du några frågor innan du börjar?",
        sendMessage: "skicka oss ett meddelande",
        allFeatures: {
          seoDirectory: {
            title: "SEO-katalog och landningssidor",
            description: "Skapa automatiskt en SEO-katalog av alla dina platser, städer och regioner"
          },
          mapPage: {
            title: "Kartsida med sök och filter",
            description: "Sök och filtrera alla dina platser på en karta driven av mapbox"
          },
          tags: {
            title: "Taggar",
            description: "Skapa taggar med bilder och beskrivningar och gruppera dem"
          },
          openingHours: {
            title: "Öppettider",
            description: "Ställ in och visa öppettider för dina platser"
          },
          mapStyles: {
            title: "Kartstilar",
            description: "Ändra utseendet på kartorna med ett antal förinställda stilar"
          },
          customFields: {
            title: "Anpassade fält",
            description: "Lägg till nya fält du vill ha, från sociala länkar till butikschef"
          },
          csvUpload: {
            title: "Ladda upp och exportera med CSV",
            description: "Ladda upp och redigera dina platser i bulk."
          },
          richSnippets: {
            title: "Rika snippets",
            description: "Hjälp Google att förstå sidor bättre med strukturerade data för lokala företag"
          },
          directionsAndCalls: {
            title: "Vägbeskrivningar och samtal",
            description: "Besökare kan enkelt få vägbeskrivningar och ringa till platserna"
          },
          languageSupport: {
            title: "Språkstöd",
            description: "Ändra standardspråk till något annat än engelska. Översättningsmallar tillhandahålls för 32 huvudspråk för enkel installation."
          }
        }
      },
      planCard: {
        bestToCustomize: "Bäst att anpassa",
        currentPlan: "Nuvarande plan",
        chooseThisPlan: "Välj denna plan",
        locationsSection: "Platser",
        featuresSection: "Funktioner",
        upTo: "Upp till",
        locations: "platser",
        tooltipTooManyLocations: "Du har för många platser och/eller aktiverade språk för denna plan."
      },
      confirmation: {
        error: "Fel vid bekräftelse av plan"
      }
    }
  },

  // Themes section
  themes: {
    title: "Teman",
    currentTheme: {
      title: "Nuvarande tema",
      description: "Detta är temat som kunderna ser när de besöker din platsapp."
    },
    themeLibrary: {
      title: "Temabibliotek", 
      description: "Hantera dina platsplats-teman. Lägg till och publicera teman för att ändra utseendet på din onlineplats."
    },
    skeleton: {
      currentThemeDescription: "Detta är temat som dina kunder ser när de använder din platsapp."
    },
    modal: {
      overrideTitle: "Åsidosätt nuvarande tema?",
      override: "Åsidosätt",
      cancel: "Avbryt",
      undoWarning: "Denna åtgärd kan inte ångras."
    },
    messages: {
      publishSuccess: "Tema publicerat framgångsrikt",
      publishError: "Kunde inte publicera tema",
      error: "Något gick fel"
    },
    emptyStates: {
      settings: {
        heading: "Detta tema har inga inställningar",
        description: "Skapa inställningar i mallredigeraren.",
        createSettings: "Skapa inställningar",
        upgradePlan: "Uppgradera plan",
        upgradeRequired: "Uppgradera plan för att skapa inställningar"
      },
      language: {
        heading: "Detta tema har inga språktermer",
        description: "Skapa språktermer i mallredigeraren.",
        createLanguageTerms: "Skapa språktermer",
        upgradePlan: "Uppgradera plan",
        upgradeRequired: "Uppgradera plan för att skapa språktermer"
      }
    },
    templates: {
      categories: {
        templates: "Mallar",
        schemas: "Scheman",
        styles: "Stilar",
        liquidReference: "Liquid-referens"
      },
      items: {
        landing: "Landning",
        directory: "Katalog",
        country: "Land",
        region: "Region",
        city: "Stad",
        location: "Plats",
        language: "Språk",
        settings: "Inställningar",
        stylesheet: "Stilmall"
      },
      errors: {
        errorsInTemplate: "Fel i mall",
        error: "Fel"
      },
      badges: {
        errors: "Fel!",
        unsaved: "Ej sparad"
      },
      actions: {
        viewTheme: "Visa tema",
        discard: "Ignorera",
        save: "Spara"
      }
    },
    language: {
      messages: {
        saveSuccess: "Temats språköversättningar sparade framgångsrikt",
        saveError: "Tema kunde inte sparas"
      },
      form: {
        language: "Språk",
        defaultLanguageHelp: "Detta är ditt standardspråk",
        translationHelp: "Redigerar översättningar för {{selectedLocale}}. Tomma fält visar innehåll från {{defaultLocale}} (ditt standardspråk)."
      },
      banner: {
        multipleLanguagesNotEnabled: {
          title: "Flera språk är inte aktiverade",
          action: "Aktivera i Inställningar",
          description: "För att hantera översättningar för flera språk, aktivera internationalisering i dina språkinställningar. Visar för närvarande endast {{locale}} översättningar."
        },
        translating: {
          title: "Redigerar {{to}} översättningar",
          description: "Alla fält du lämnar tomma kommer automatiskt att visa {{defaultLocale}} innehållet till dina kunder. Översätt endast de fält där du vill ha olika innehåll i {{selectedLocale}}."
        }
      },
      accessLanguageTerms: "Få tillgång till {{category}} språktermer i liquid med {{code}}",
      fields: {
        // Common language fields - add specific ones as needed
        title: "Titel",
        description: "Beskrivning",
        heading: "Rubrik",
        subheading: "Underrubrik",
        button_text: "Knapptext",
        link_text: "Länktext",
        placeholder: "Platshållare",
        label: "Etikett",
        help_text: "Hjälptext",
        error_message: "Felmeddelande",
        success_message: "Framgångsmeddelande",
        
        // Opening hours
        Monday: "Måndag",
        Tuesday: "Tisdag",
        Wednesday: "Onsdag",
        Thursday: "Torsdag",
        Friday: "Fredag",
        Saturday: "Lördag",
        Sunday: "Söndag",
        opening_hours_format: "Öppettider format",
        closes_at_format: "Stänger kl format",
        opens_at_format: "Öppnar kl format",
        opens_on: "Öppnar på",
        open_24h: "Öppen 24 timmar",
        open: "Öppen",
        closed: "Stängd",
        closes_at: "Stänger kl",
        opens_at: "Öppnar kl",
        
        // Map
        search_map: "Sök på karta",
        search_area: "Sök i detta område",
        view_map: "Karta",
        view_list: "Lista",
        open_filters: "Filter",
        stores_near_you: "Butiker nära dig",
        header: "Hitta en butik!",
        search_placeholder: "Skriv ett postnummer eller adress...",
        no_listings: "Vi beklagar, vi kan inte hitta några platser för din sökning. Försök ändra filtren eller söklokationen",
        
        // Directory
        view_directory: "Butikskatalog",
        
        // Location
        get_directions: "Vägbeskrivningar",
        call: "Ring",
        view_website: "Webbplats",
        email: "E-post",
        opening_hours_header: "Öppettider",
        description_header: "Information",
        phone_number_header: "Telefon",
        address_header: "Adress",
        tag_groups_to_display: "Tagg grupper att visa"
      },
      categories: {
        // Common language categories - add specific ones as needed
        general: "Allmänt",
        navigation: "Navigering",
        forms: "Formulär",
        buttons: "Knappar",
        messages: "Meddelanden",
        errors: "Fel",
        opening_hours: "Öppettider",
        map: "Karta",
        directory: "Katalog",
        location: "Plats"
      }
    },
    settings: {
      messages: {
        saveSuccess: "Tema sparad framgångsrikt",
        saveError: "Tema kunde inte sparas"
      },
      accessSettings: "Få tillgång till {{category}} inställningar i liquid med {{code}}",
      fields: {
        // Colors
        color_text: "Textfärg",
        color_text_heading: "Rubriktextfärg", 
        color_background: "Bakgrundsfärg",
        color_accent: "Accentfärg",
        color_text_positive: "Positiv textfärg",
        color_text_negative: "Negativ textfärg",
        dark_theme: "Mörkt tema",
        color_marker: "Markörfärg",
        color_search_marker: "Sökmarkörfärg",
        
        // Typography
        base_font_size: "Basstorlek för typsnitt",
        
        // Buttons
        border_radius: "Kantradie",
        
        // Images
        aspect_ratio: "Bildförhållande",
        fit: "Passa",
        
        // Spacing
        page_width: "Sidbredd",
        page_width_small: "Sidbredd liten",
        gutter_desktop: "Gutter desktop",
        gutter_mobile: "Gutter mobil",
        desktop_vertical_spacing: "Vertikal avstånd desktop",
        mobile_vertical_spacing: "Vertikal avstånd mobil",
        
        // Breakpoints
        breakpoint_xs: "Brytpunkt XS",
        breakpoint_sm: "Brytpunkt SM",
        breakpoint_md: "Brytpunkt MD",
        
        // Map
        search_on_move: "Sök vid flytt",
        scroll_to_zoom: "Scrolla för att zooma",
        
        // Landing page
        sidebar_width: "Sidofältbredd",
        sidebar_min_height: "Sidofält minsta höjd",
        marker_image_src: "Markörbildkälla",
        show_filter_descriptions: "Visa filterbeskrivningar",
        
        // Location page
        tag_groups_to_display: "Tagg grupper att visa",
        tag_groups_to_display_as_icons: "Tagg grupper att visa som ikoner",
        show_related_locations: "Visa relaterade platser",
        
        // Locations
        hide_regions: "Dölj regioner"
      },
      categories: {
        colors: "Färger",
        typography: "Typografi",
        buttons: "Knappar",
        images: "Bilder",
        spacing: "Avstånd",
        breakpoints: "Brytpunkter",
        map: "Karta",
        landing_page: "Landningssida",
        location_page: "Platssida",
        locations: "Platser"
      }
    },
    navigation: {
      sublimeTheme: "Sublime Tema",
      settings: "Inställningar",
      language: "Språk",
      templates: "Mallar",
      changeTheme: "Ändra tema",
      viewDirectory: "Visa katalog",
      viewLandingPage: "Visa landningssida"
    },
    card: {
      lastUpdated: "Senast uppdaterad",
      view: "Visa",
      customize: "Anpassa",
      publish: "Publicera",
      actions: "Åtgärder"
    }
  },

  // Analytics section
  analytics: {
    title: "Analys",
    timePeriods: {
      last7days: "Senaste 7 dagarna",
      last30days: "Senaste 30 dagarna"
    },
    comparison: {
      compareToPrevious: "Jämför med föregående period",
      stopComparing: "Sluta jämföra med föregående period"
    },
    sections: {
      searchLocations: "Sökplatser"
    },
    cards: {
      sessions: "Sessioner",
      topSearches: "Toppsökningar",
      topLandingPageType: "Topp landningssida typ",
      topPageViewsBySession: "Topp sidvisningar per session",
      topLocations: "Topp platser",
      topReferrers: "Topp hänvisningar",
      searches: "Sökningar",
      topLandingPagesBySession: "Topp landningssidor per session"
    },
    chartLabels: {
      desktop: "Desktop"
    }
  },

};
